import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function StockEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["product.name", "product.sku"]} children={children} />
    );
}

export function StockCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"stock"} children={children} />
    );
}